import apiClient from './apiClient';

export const changePassword = async(password,token) =>{
    try{
        const response = await apiClient.post('/auth/change_password',{password},{headers:{Authorization:token}})
        return response.data
    }catch(error){
        console.log(error)
    }

}